import { forwardRef, type HTMLProps } from 'react';

import { cn } from '../../../tailwind';

type TailwindDropdownProps = HTMLProps<HTMLDivElement>;

export const TailwindDropdownSection = forwardRef<
  HTMLDivElement,
  TailwindDropdownProps
>(({ className, children, ...props }, ref) => (
  <div className={cn('flex flex-col gap-6', className)} ref={ref} {...props}>
    {children}
  </div>
));

export const TailwindDropdownHeader = forwardRef<
  HTMLDivElement,
  TailwindDropdownProps
>(({ className, children, ...props }, ref) => (
  <div
    className={cn('flex justify-between items-baseline gap-4', className)}
    ref={ref}
    {...props}
  >
    {children}
  </div>
));

export const TailwindDropdownTitle = forwardRef<
  HTMLDivElement,
  TailwindDropdownProps
>(({ className, children, ...props }, ref) => (
  <div className={cn('text-lg font-medium', className)} ref={ref} {...props}>
    {children}
  </div>
));

export const TailwindDropdownContent = forwardRef<
  HTMLDivElement,
  TailwindDropdownProps
>(({ className, children, ...props }, ref) => (
  <div
    className={cn('grid grid-cols-2 gap-x-4 gap-y-6', className)}
    ref={ref}
    {...props}
  >
    {children}
  </div>
));
